import { Sun, Moon } from "lucide-react";
import { useTheme } from "@/hooks/useTheme";

export const ThemeSettings = () => {
  const [theme, setTheme] = useTheme();
  const dark = theme === "dark";
  return (
    <section data-testid="theme-settings" className="mt-6 rounded-2xl border border-[#E2E7F7] bg-white p-5 shadow-[0_1px_2px_rgba(15,38,69,0.04)] sm:p-6">
      <div className="flex flex-wrap items-center justify-between gap-4">
        <div className="min-w-0">
          <h2 className="font-heading text-[15px] font-bold text-[#0F2645]">Apparence de l'espace Studio</h2>
          <p className="mt-0.5 text-xs text-[#5C6A87]">Mode sombre pour travailler confortablement le soir. Réglage propre à cet appareil ; les pages vues par vos clients restent claires.</p>
        </div>
        <div role="radiogroup" aria-label="Thème" className="inline-flex rounded-xl border border-[#E2E7F7] bg-[#F6F8FD] p-1">
          <button type="button" role="radio" aria-checked={!dark} data-testid="theme-light" onClick={() => setTheme("light")}
            className={`inline-flex h-9 items-center gap-1.5 rounded-xl px-3.5 text-xs font-semibold transition-colors ${!dark ? "bg-white text-[#0F2645] shadow-[0_1px_2px_rgba(15,38,69,0.08)]" : "text-[#5C6A87] hover:text-[#0F2645]"}`}>
            <Sun className="h-3.5 w-3.5" /> Clair
          </button>
          <button type="button" role="radio" aria-checked={dark} data-testid="theme-dark" onClick={() => setTheme("dark")}
            className={`inline-flex h-9 items-center gap-1.5 rounded-xl px-3.5 text-xs font-semibold transition-colors ${dark ? "bg-[#0F2645] text-white" : "text-[#5C6A87] hover:text-[#0F2645]"}`}>
            <Moon className="h-3.5 w-3.5" /> Sombre
          </button>
        </div>
      </div>
    </section>
  );
};
